import { DropdownWrap, DropdownMenu } from './style'

const Dropdown = ({ children, className, ...props }) => {
  return (
    <DropdownWrap className={className} {...props}>
      <DropdownMenu>{children}</DropdownMenu>
    </DropdownWrap>
  )
}

export default Dropdown
